import { Sucursal } from "../../entities/catalogos/Sucursal";

export const LOAD_SUCURSALES_MANY_SUCCESS = 'LOAD_SUCURSALES_MANY_SUCCESS';


interface ILoadSucursalesMany {
    type: typeof LOAD_SUCURSALES_MANY_SUCCESS
    sucursalesMany: Sucursal[]
}

export type SucursalManyActionTypes = ILoadSucursalesMany
